const dataSet = document.getElementById('root').dataset;
const date = dataSet.salesdate;
const venue = dataSet.venueid;

/**
 * Catalogue header tabs config
 */
export default [
    {
        name: 'Catalogue',
        link: `/bloodstock/sales/catalogues/${venue}/${date}`
    },
    {
        name: 'Sires',
        link: `/bloodstock/sales/catalogues/${venue}/${date}/sires`
    },
    {
        name: 'Previously offered lots',
        link: `/bloodstock/sales/catalogues/${venue}/${date}/previously-offered-lots`
    },
    {
        name: 'Vendors',
        link: `/bloodstock/sales/catalogues/${venue}/${date}/vendors`
    }
];



// WEBPACK FOOTER //
// ./src/js/config/tabsConfigCatalogues.js